import { AxiosResponse } from 'axios';
import api from '../contexts/GlobalContext';

const downloadFile = async (requestData: any): Promise<AxiosResponse<Blob>> => {
    return api.post('/excel/download', requestData, { responseType: 'blob' });
}

export default {
    downloadFile,
};
